module.exports = __webpack_public_path__ + "media/images/sales/smakon/thumb-pricing-02-38a10c125b74a2a4ee27e43ac26dac57.svg";